/**
 * @param node {HTMLInputElement}
 * @return {String}
 * */
function getInputMask (node) {
  return node.iMask.mask[0].mask || node.iMask.mask
}

/**
 * @param mask {String}
 * @return {String}
 * */

function toNormalMask (mask) {
  const els = [
    {
      selector: '0',
      replaceVal: '[0-9]'
    },
    {
      selector: '(',
      replaceVal: '[(]?'
    },
    {
      selector: ')',
      replaceVal: '[)]?'
    }
  ]
  const indexOfSeparate = mask.indexOf(' ')
  let newMask = mask.slice(indexOfSeparate)

  els.forEach(item => {
    newMask = newMask.replaceAll(item.selector, item.replaceVal)
  })

  return '[0-9]{*}?' + newMask
}

export { getInputMask, toNormalMask }
